<template>
  <div class="news-wrap">
    <div>
      <div class="bannerbox">
        <!-- <el-image fit="cover" :src="require('@/assets/imgs/banner.png')">
                </el-image> -->
        <div class="banner">
          <img

            src="@/assets/imgs/exhibition.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="newsbox">
        <div
          class="clearfix wrap"
          style="padding-top: 60px; padding-bottom: 60px"
        >
          <div class="menutitle">
            <el-breadcrumb separator-class="el-icon-arrow-right">

              <el-breadcrumb-item :to="{ path: '/display' }"
                >陈列展览</el-breadcrumb-item
              >
              <el-breadcrumb-item :to="{ path: '/displayYugao' }"
                >展览预告</el-breadcrumb-item
              >
            </el-breadcrumb>
          </div>
          <!-- <div class="newscontent">
            <h3 class="title">春风十里——京津小幅风景油画邀请展</h3>
            <p>发布日期：2021-03-09 浏览次数：913次</p>
            <h4>
              主办：上饶美术馆<br />
              展期：2021年3月12日-2021年4月20日<br />
              展厅：一号展厅（一层）<br /><br />
              辛丑农历新年刚过，“草树知春”的时节便如期而至。
              由天津美术馆主办的“春风十里—京津小幅风景油画
              邀请展”于2021年3月12日至4月20日与观众见面，意在
              为我们这座城市的艺术园地及精神文化生活，带来一片
              春的明媚与春的色彩。受邀参加此次展览的艺术家们来自
              于京津两地。他们之中有享誉国内美术界的老艺术家，也
              有正值创作盛年的画坛翘楚，还有活力充沛的青年才俊。<br /><br />
            </h4>
            <img src="@/assets/imgs/newsimg.png" alt="" />
          </div> -->
          <div class="newscontent">
            <h3 class="title">{{ arrlist.title }}</h3>
            <p>
              <span> 发布日期：{{ arrlist.publishTime }}</span>
              <span>浏览次数：{{ arrlist.viewCount }}次</span>
            </p>
            <div class="content">
              主办方：{{ arrlist.sponsor }}<br />
              <span v-html="'展&emsp;期：'"></span>{{ arrlist.startTime }}至{{
                arrlist.endTime
              }}<br />
              <span v-html="'展&emsp;厅：'"></span>{{ arrlist.hall
              }}<br /><br />
            </div>
            <h4 v-html="arrlist.content"></h4>
            <img v-lazy="img" alt="" />
          </div>
          <rigthBox
            :list="rigthBoxData"
            :sidebarTitle="sidebarTitle"
          ></rigthBox>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import rigthBox from "@/components/rigthBox";
export default {
  components: {
    rigthBox,
  },
  data() {
    return {
      img: "",
      sidebarTitle: "陈列展览",
      rigthBoxData: [
        {
          name: "正在展览",
          index: "menu1",
          path: "/nowplay",
          children: [],
        },
        {
          name: "展览预告",
          index: "menu2",
          path: "/displayYugao",
          children: [],
        },
        {
          name: "展览回顾",
          index: "menu3",
          path: "/displayreview",
          children: [],
        },
      ],
      id: "",
      arrlist: [],
    };
  },
  created() {
    this.id = window.location.hash;
    this.id = this.id.split("?")[1];
    this.id = this.id.split("=")[1];
  },
  async mounted() {
    var that = this;
    await this.$axios.get(`/frontapi/expo/main/${that.id}`).then(function(res) {
      that.arrlist = res.data.data;
    });
    await this.$axios
      .get(`/common/fileInfo/${that.arrlist.imgId}`)
      .then((res) => {
        // that.arrlist.filePath =   that.$axios.defaults.baseURL + res.data.data[0].filePath;

        this.img = that.$axios.defaults.baseURL + res.data.data[0].filePath;
        console.log(this.img, "this is img");
      });
  },
};
</script>
<style scoped>
::v-deep .mapTipWindow li {
    font-size: 18px;
}
img {
    font-size: 18px;
}
* {
  margin: 0;
  padding: 0;
}
.news-wrap {
  padding-top: 1.111111rem /* 80px -> 1.111111rem */;
  width: 100%;
    background-color: #f4f4f4;
}
.wrap {
  margin: 0 auto;
  width: 1200px;
  background: #f4f4f4;
}
.banner {
  height: auto;
  width: 100%;
}
.newsbox {
  background: #f4f4f4;
}
.clearfix:after {
  display: block;
  content: "";
  overflow: hidden;
  clear: both;
  height: 0;
}
.news-wrap >>> .menutitle {
  cursor: pointer;
}
.news-wrap >>> .is-link {
  font-weight: 400;
  color: #606266;
  cursor: pointer;
}
.menutitle >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: 700;
  color: #303133;
  cursor: pointer;
}
.newscontent {
  width: 860px;
  min-height: 903px;
  height: auto;
  background: #ffffff;
  float: left;
  margin-top: 40px;
  padding: 0 30px;
  border-radius: 10px;
  overflow: hidden;
}
.newscontent h3 {
  text-align: center;
  /* height: 25px; */
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  line-height: 25px;
}
.newscontent p {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #666666;
  line-height: 54px;
  margin-top: 8px;
  /* text-align: center; */
  margin: 0 auto;
  width: 280px;
  display: flex;
  justify-content: space-between;
}
.newscontent h4 {
   font-size: 16px;
  line-height: 26px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
}
.newscontent .content {
  font-size: 18px;
  line-height: 20px;
  /*height: 60px;*/
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  margin-bottom: 20px;
}
.newscontent img {
  width: 660px;
  height: 300px;
  margin: 20px auto;
  display: block;
}
.service {
  width: 309px;
  height: 903px;
  background: #ffffff;
  float: right;
  margin-top: 40px;
  padding: 0 30px;
  border-radius: 10px;
}
.title {
  /* overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  line-height: 25px;
  margin-top: 30px;
}
.til {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #222222;
  line-height: 56px;
}
.service ul {
  margin-bottom: 70px;
}
.service li {
  border-bottom: 1px solid #eeeeee;
}
.service li {
  border-bottom: 1px solid #eeeeee;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #999999;
  line-height: 56px;
  cursor: pointer;
}
.service .active {
  color: #b78c0d;
}
.service hr {
  height: 1px;
  border: none;
  border-top: 1px solid #222222;
  margin-top: 30px;
}
.tips {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 26px;
}
.map {
  width: 100%;
  height: 103px;
}
.order {
  width: 100%;
  height: 40px;
  border: 1px solid #b78c0d;
  border-radius: 4px 4px 4px 4px;
  background: #fff;
  color: #b78c0d;
  margin-top: 20px;
}
</style>
